import { Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentService } from '../../../services/document.service';
import { ChunkUploadRequest, ChunkUploadResponse } from '../../../interfaces/document.interface';
import { CollectionName, COLLECTION_NAME_MAPPING } from '../../../../../shared/enums/collection-name.enum';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { CollectionEventsService } from '../../../../../shared/services/collection.service';

@Component({
  selector: 'app-upload-chunk-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './upload-chunk-modal.component.html',
  styleUrls: ['./upload-chunk-modal.component.css']
})
export class UploadChunkModalComponent implements OnDestroy {
  @Input() collectionName: string = '';
  @Output() chunkUploadConfirmed = new EventEmitter<{chunkName: string, chunkContent: string}>();

  chunkName: string = '';
  chunkContent: string = '';
  dragOver: boolean = false;
  isUploading: boolean = false;
  private uploadSubscription?: Subscription;

  constructor(
    public activeModal: NgbActiveModal,
    private documentService: DocumentService,
    private toastr: ToastrService,
    private collectionEvents: CollectionEventsService
  ) {}

  onCancel() {
    this.activeModal.dismiss();
  }

  onUpload() {
    if (this.chunkName.trim() && this.chunkContent.trim()) {
      this.isUploading = true;
      
      const uploadRequest: ChunkUploadRequest = {
        chunkName: this.chunkName.trim(),
        chunkDescription: this.chunkContent.trim(),
        collectionName: this.getCollectionNameEnum()
      };

      this.uploadSubscription = this.documentService.uploadChunk(uploadRequest).subscribe({
        next: (response: ChunkUploadResponse) => {
          if (response.isSuccess) {
            this.toastr.success('Text uploaded successfully!');
            this.chunkUploadConfirmed.emit({
              chunkName: this.chunkName.trim(),
              chunkContent: this.chunkContent.trim()
            });
            this.collectionEvents.triggerReload();
            this.activeModal.close();
          } else {
            this.toastr.error(response.message || 'Upload failed');
            this.isUploading = false;
          }
        },
        error: (error: any) => {
          this.isUploading = false;
        }
      });
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.dragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.dragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.dragOver = false;
  }

  ngOnDestroy(): void {
    if (this.uploadSubscription) {
      this.uploadSubscription.unsubscribe();
    }
  }

  private getCollectionNameEnum(): CollectionName {
    const collectionNameLower = this.collectionName.toLowerCase();
    
    for (const [key, value] of Object.entries(COLLECTION_NAME_MAPPING)) {
      if (collectionNameLower.includes(key)) {
        return value;
      }
    }
    
    return CollectionName.STRUCTURED_DOCUMENT_COLLECTION;
  }
}
